import AbstractRuleModelVisitor from "../../../models/forecast/ruleModels/AbstractRuleModelVisitor.js";

/**
 * This {@link AbstractRuleModel} visitor returns an array of
 * assumption specifications. Each assumption specification could then
 * be used as parameter to create instances of {@link Assumption}.
 */
export default class RuleModelToAssumptionSpecsVisitor extends AbstractRuleModelVisitor {
	visitAbstractRuleModel() {
		return [];
	}

	visitManualEntryRuleModel(ruleModel) {
		return [
			{
				name: ruleModel.getName(),
				value: ruleModel.getValue(),
				vatRate: ruleModel.getVatRate(),
				paymentSpread: ruleModel.getPaymentSpread(),
			},
		];
	}

	visitManualJournalEntryRuleModel(ruleModel) {
		return ruleModel.getTransactions().map((transaction) => ({
			account: transaction.getAccount(),
			value: transaction.getValue(),
			name: ruleModel.getName(),
		}));
	}

	visitAbstractPredictionRuleModel(ruleModel) {
		return [{ description: ruleModel.getDescription() }];
	}

	visitLinearRegressionPredictionRuleModel(ruleModel) {
		return [
			{
				...super.visitLinearRegressionPredictionRuleModel(ruleModel)[0],
				historicalInput: ruleModel.getShift(),
			},
		];
	}

	visitSingularSpectrumAnalysisRuleModel(ruleModel) {
		return [
			{
				...super.visitSingularSpectrumAnalysisRuleModel(ruleModel)[0],
				historicalInput: ruleModel.getShift(),
			},
		];
	}

	visitConstantPredictionRuleModel(ruleModel) {
		return [
			{
				...super.visitConstantPredictionRuleModel(ruleModel)[0],
				value: ruleModel.getInitialValue(),
				growthPercentage: ruleModel.getGrowthPercentage(),
			},
		];
	}

	visitFromActualsPredictionRuleModel(ruleModel) {
		return [
			{
				...super.visitFromActualsPredictionRuleModel(ruleModel)[0],
				historicalInput: ruleModel.getShift(),
				growthPercentage: ruleModel.getGrowthPercentage(),
			},
		];
	}

	visitSeasonalTrendPredictionRuleModel(ruleModel) {
		return [
			{
				...super.visitSeasonalTrendPredictionRuleModel(ruleModel)[0],
				historicalInput: ruleModel.getShift(),
			},
		];
	}
}
